import React, {useContext, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate} from "react-router-dom";
import {Button, Form, Input} from "antd";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {GetInscripcions} from "../../dao/inscripcions/GetInscripcions";
import Inscripcio from "../../model/inscripcions/Inscripcio";
import toast, {Toaster} from "react-hot-toast";
import NouUsuariModal from "./components/NouUsuariModal";

const LoginInscripcions = () => {
    const [usuari, setUsername] = useState('');
    const [usuariTMP, setUsernameTMP] = useState('');
    const [password, setPassword] = useState('');
    const [passwordTMP, setPasswordTMP] = useState('');
    const [dades, setDades] = useState<Inscripcio>();
    const [routes, setRoutes] = useState([]);
    const [visible, setVisible] = useState(false);
    const {
        isLoggedIn, setLoggedIn, userId, setUserId, user, setUserPermissos, setPage, page
        , setToken, token, setUserCognom, setUserDni
    } = useContext(AuthContext);

    const navigate = useNavigate();

    const check = async (usuari: string, dni: string) => {
        setUsernameTMP(usuari);
        setPasswordTMP(dni);
        const dades = await GetInscripcions(usuari, dni, window.location.href);
        setDades(dades);
        if (dades.length !== 0) {
            setLoggedIn(true);
            setUserDni(dni);
            setUserCognom(usuari);
            setPage(window.location.href);
            navigate('/inscripcions/gestio');
        } else {
            toast.error('Usuari o password incorrecte');
            setVisible(true);
            setLoggedIn(false);
            setUserDni('');
            setUserCognom('');
            setPage('');
        }
    };

    function isBrowserCompatible() {
        // Comprueba si el navegador soporta características clave
        return 'fetch' in window && 'Promise' in window && 'assign' in Object;
    }



    const onFinish = (values: any) => {
        check(values.username, values.dni);
    };

    function onClose(acceptar : boolean) {
        if (acceptar) {
            if (passwordTMP !== '' && usuariTMP !== '') {
                setLoggedIn(true);
                setUserDni(passwordTMP);
                setUserCognom(usuariTMP);
                setPage(window.location.href);
                navigate('/inscripcions/gestio');
            } else {
                toast.error("Falten dades, torna-ho a intentar...");
            }
        }
        setVisible(false);
    }

    return (
        isBrowserCompatible() ? (
            <React.Fragment>
                <br/>
                <br/>
                <br/>
                <h4 className={"titol"}>INSCRIPCIONS:</h4>
                <Form
                    name="normal_login"
                    className="login-form login-container container-sm"
                    initialValues={{remember: true}}
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="username"
                        rules={[{required: true, message: 'Primer cognom. Si vols crear nou usuari posa el Primer cognom igualment.'}]}
                    >
                        <Input prefix={<UserOutlined className="site-form-item-icon"/>}
                               placeholder="Primer cognom (mare, pare, tutor/a legal...)"/>
                    </Form.Item>
                    <Form.Item
                        name="dni"
                        rules={[{required: true, message: 'DNI. Si vols crear nou usuari posa el DNI igualment.'}]}
                    >
                        <Input
                            prefix={<LockOutlined className="site-form-item-icon"/>}
                            type="dni"
                            placeholder="DNI (mare, pare, tutor/a legal..."
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button className={"login-button-insc"} type="primary" htmlType="submit">
                            Accedir / Crear usuari
                        </Button>
                    </Form.Item>
                </Form>
                <Toaster
                    position="top-center"
                    reverseOrder={false}
                />
                <NouUsuariModal visible={visible} page={page} onClose={onClose} />
            </React.Fragment>
        ) : (
            <h2>No es poden fer inscripcins des d'aquest navegador...</h2>
        )
    );
};
export default LoginInscripcions;
